import React from "react";
import { motion } from "framer-motion";
import styles from "./Aboutus.module.css";
import { useMotion } from "../../../Logic/Functions/Hooks/useMotion";
import { IOurVisionProps } from "../../../Model/Aboutus.model";

const OurVision: React.FC<IOurVisionProps> = ({
  data,
  once = false,
  triggerAmount = 0.2,
}) => {
  const { slideFade, containerStagger } = useMotion();

  return (
    <section
      className={`${styles.section} ${styles.visionTheme} ${styles.fiveUp}`}
      data-testid="about-vision"
    >
     
      <motion.h2
        className={styles.sectionTitle}
        data-testid="about-vision-title"
        variants={slideFade("left", 0)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        {data.title}
      </motion.h2>

      
      <motion.p
        className={styles.sectionSub}
        data-testid="about-vision-subtitle"
        variants={slideFade("right", 0.05)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        {data.subtitle}
      </motion.p>

      
      <motion.h3
        className={styles.sectionMinorTitle}
        data-testid="about-vision-mission-title"
        variants={slideFade("up", 0.1)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        Our Mission
      </motion.h3>

      
      <motion.div
        className={styles.cardRow}
        data-testid="about-vision-cards"
        variants={containerStagger(0.15)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        {data.cards.map((card, i) => (
          <motion.article
            key={`${card.title}-${i}`}
            className={`${styles.cardSoft} ${styles.cardCompact}`}
            data-testid={`about-vision-card-${i}`}
            variants={slideFade("up", 0.03 * i)}
          >
            <h3
              className={styles.cardTitle}
              data-testid={`about-vision-card-${i}-title`}
            >
              {card.title}
            </h3>
            <p
              className={styles.cardBody}
              data-testid={`about-vision-card-${i}-description`}
            >
              {card.description}
            </p>
          </motion.article>
        ))}
      </motion.div>
    </section>
  );
};

export default OurVision;
